import { useState, useEffect } from "react";
import styled from "@emotion/styled";
import Button from "../../../customs/Button";
import { FaTimes as CancelIcon } from "react-icons/fa";
import { DocumentBarProps } from "./type";

const DocumentBar = ({
  documentUrl,
  docName,
  score,
  handleVisibility = () => {},
  handleSubmit = async () => {},
  onChange,
  loading,
  hideScoreIntegration = false,
  displayScore,
  isReadOnly = false // ✅ default
}:

DocumentBarProps) => {
  const [scoreValue, setScoreValue] = useState("");

  const [showCard, setShowCard] = useState(false);

  const handleSingleVisibility = () => {
    handleVisibility();
    setShowCard(!showCard);
  };
  const handleSubmitSingle = async () => {
    await handleSubmit();
    setShowCard(!showCard);
  };

  const handleSingleClose = () => {
    setShowCard(!showCard);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setScoreValue(e?.target?.value);
  };

  // useEffect(() => {
  //   onChange(scoreValue);
  // }, [onChange, scoreValue]);

  return (
    <DocumentContainer>
      <StyledLink>
        <span>{docName}</span>
        <span>
          {hideScoreIntegration && (
            <>
  <span>
  {!isReadOnly && hideScoreIntegration && (
    <span style={{ marginInlineEnd: "10px" }}>
      <span>Score: {displayScore}</span>

      <Button
        bg={"#FFFFFF"}
        color={"#11643C"}
        paddingBlock={"5px"}
        borderRadius={"3px"}
        text={"Edit Score"}
        maxWidth="102px"
        border={"1px solid #11643C"}
        onClick={handleSingleVisibility}
      />

      {showCard && (
        <div>
          <div className="header">
            Edit Score
            <button onClick={handleSingleClose}>
              <CancelIcon />
            </button>
          </div>

          <div className={"body"}>
            <label>Score</label>
            <input
              type="text"
              value={score}
              onChange={onChange}
            />

            <button className="button" onClick={handleSubmitSingle}>
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      )}
    </span>
  )}
</span>
            </>
          )}
          <a href={documentUrl} target="_blank" rel="noreferrer">
            <Button
              paddingBlock={"5px"}
              borderRadius={"3px"}
              text={"View"}
              maxWidth="66px"
            />
          </a>
        </span>
      </StyledLink>
    </DocumentContainer>
  );
};

export default DocumentBar;

const DocumentContainer = styled.div`
  width: 100%;
  margin-block-start: 5px;
  border-radius: 5px;
  & > span {
    font-weight: bold;
  }
`;
const StyledLink = styled.div`
  display: flex;
  width: fit-content;
  margin-block-start: 4px;
  padding-inline: 7px;
  gap: 10px;
  background: #f7f8fa;
  border-radius: 5px;
  text-decoration: none;
  & > span {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }

  & > span:nth-child(1) > span {
    margin-left: 14.5px;
  }

  & > span:nth-child(2) > span:nth-child(1) {
    margin-right: 14.5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    background: #f8e8ac;
    padding-inline: 2px;
    white-space: nowrap;
  }
  & > span:nth-child(2) > span:nth-child(2) {
    position: relative;

    & > div {
      position: absolute;
      left: -164px;
      z-index: 10;
      top: 44px;
      border-radius: 4px;
      width: 248px;
      background: #ffffff;
      & > .header {
        display: flex;
        justify-content: space-between;
        border: 1px solid #ebebeb;
        border-bottom: 0px;
        padding: 16px 20px;
        font-weight: 500;
      }
      & > .header button {
        border: none;
        background-color: transparent;
        cursor: pointer;
      }
      & > .body {
        border: 1px solid #ebebeb;
        padding: 16px 20px;
        position: relative;
        margin-block-end: 40px;
      }
      & > .body label {
        font-weight: 500;
      }
      & > .body > input {
        display: flex;
        justify-content: space-between;
        background: #f6fbf3;
        border: 1px solid #8dc467;
        border-radius: 4px;
        outline: none;
        width: 100%;
        height: 56px;
        padding-inline-start: 15px;
        color: #666666;
        font-weight: 400;
      }
      & > .body > button {
        background-color: #5bc065;
        border: 1px solid #5bc065;
        border-radius: 4px;
        width: 67px;
        height: 36px;
        color: #ffffff;
        position: absolute;
        top: 47px;
        right: 27px;
        cursor: pointer;
      }
    }
  }
  & > span:nth-child(2) > a {
    text-decoration: none;
    cursor: pointer;
    color: #11643c;
  }
`;
